import { Component, EventEmitter, Input, Output } from '@angular/core';
import { defaultDetailDateFormatLong } from 'src/app/shared/utils/date.utils';
import { MaintenanceModeNotificationViewModel } from 'src/proxy';

@Component({
    selector: 'app-maintenance-mode-alert',
    templateUrl: './maintenance-mode-alert.component.html',
    styles: [``],
    standalone: false
})
export class MaintenanceModeAlertComponent  {
  defaultfilterFullDatetimeFormatGMT = defaultDetailDateFormatLong;
  @Input() dateInfo: MaintenanceModeNotificationViewModel = null;
  @Output() closeModal = new EventEmitter<boolean>();
  constructor() { }

  closeMaintenanceDialog() {
    this.closeModal.emit(false);
  }
}
